import './custom_assignments' // Defines ALL (window-)global custom vars/consts: ensure to correctly overwrite below
import { overwriteColors } from './colors_geoenergy'
import { overwriteCoreuiDeviceIcons, overwriteIcons } from './icons_geoenergy'

overwriteColors()
overwriteIcons()
overwriteCoreuiDeviceIcons()
